import { render, staticRenderFns } from "./MarketingReport.vue?vue&type=template&id=31d761d8&scoped=true"
import script from "./MarketingReport.vue?vue&type=script&lang=ts"
export * from "./MarketingReport.vue?vue&type=script&lang=ts"
import style0 from "./MarketingReport.vue?vue&type=style&index=0&id=31d761d8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d761d8",
  null
  
)

export default component.exports